import { gql, TypedDocumentNode } from '@common/hooks';
import {
  TimekeepingHolidaysQueryCgResponse,
  TimekeepingHolidaysQueryVariables,
} from '@common/graphql/schema';
import { TimekeepingHoliday } from '@timekeeping/graphql';

export const TimekeepingHolidays: TypedDocumentNode<
  TimekeepingHolidaysQueryCgResponse,
  TimekeepingHolidaysQueryVariables
> = gql`
  query TimekeepingHolidays($year: Int!) {
    page: worksTimekeepingHolidays(year: $year) {
      hasNext
      hasPrev
      holidays {
        ...TimekeepingHoliday
      }
    }
  }
  ${TimekeepingHoliday}
`;
